import { featureFlags } from "#/config/featureFlags";
import { NoticeBanner } from "#/types/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useNoticeBannerFeatureFlag = () => {
  return useFeatureFlags<Array<NoticeBanner>>(featureFlags.noticeBanner) ?? [];
};
